/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router';
import { useHistory } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Radio from '@material-ui/core/Radio';
import Box from '@material-ui/core/Box';
import { Button, Dropdown } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import _ from 'lodash';
import moment from 'moment';

// variable custom import
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { tabHighLigther } from '../../../../SharedModules/utilities/utilities';
import {
  TableHeaderForDisputesDetails,
  TableHeaderForDisputesCorrespondence,
} from './gridComponents/tablehead';
import {
  dispatchDisputeHeaderDetails,
  getMainGridDetails,
  dispatchSingleHeaderDetails,
  getDisputeNdcDetails,
  singleDisputeNDCDetails,
  getAllCorrespondenceDetails,
  dispatchDisputeBodyDetails,
  selectionList,
  dispatchDisputeCorrespondenceTable,
  handleErrorDetail,
  getExistingCorrLinkIds,
  statusType,
  getDisplayRecapGrid,
} from '../store/actions';

function ManufacturerDisputesDetail(props) {
  const dispatch = useDispatch();

  const rebateProgramList = useSelector(
    (state) => state.sharedState.DisputesReducer.dropdownUpdatedList
  );
  const disputeHeaderDetails = useSelector(
    (state) =>
      state.sharedState.DisputesReducer.disputeManufacturerHeaderDetails
  );
  const singleHeaderDetails = useSelector(
    (state) => state.sharedState.DisputesReducer.singleHeaderDetails
  );
  const disputeManufacturerBodyDetails = useSelector(
    (state) => state.sharedState.DisputesReducer.disputeManufacturerBodyDetails
  );
  const getSelectionList = useSelector(
    (state) => state.sharedState.DisputesReducer.selection_list
  );
  const disputeCorrespondenceDetails = useSelector(
    (state) => state.sharedState.DisputesReducer.disputeCorrespondenceDetails
  );
  const detailErrorMessages = useSelector(
    (state) => state?.sharedState?.DisputesReducer?.detailErrorMessages
  );
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });

  // variable declaration
  const gridRef = React.useRef();
  const [loading, setLoading] = React.useState(false);
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [showAllCheckbox, setShowAllCheckbox] = React.useState(
    getSelectionList?.showAllCorrespondence
      ? getSelectionList?.showAllCorrespondence
      : false
  );

  const [paramsStore, setParamsStore] = React.useState();
  const [showComments, setShowComments] = React.useState(false);
  const [comments, setComments] = React.useState([]);
  const [linkTable, setLinkTable] = React.useState('');
  const [corrLinkId, setCorrLinkId] = React.useState('');
  const [checkKey, setCheckKey] = React.useState(true);
  const [stateCC, setStateCC] = React.useState(true);
  const [stateGridCC, setStateGridCC] = React.useState(false);
  const [textBoxPaginate, setTextBoxPaginate] = React.useState();

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };
  // handling existing comments to enable/disable icon
  const callCommentsExisting = async (value, condition) => {
    const result = await getExistingCorrLinkIds({
      corrLinkId: [value],
    });
    if (condition === 'top') setComments(result?.data);
    return result;
  };

  // fetching mainGrid disputes table data based on pagination
  const getMainGridTableDetails = (headerDetails) => {
    callCommentsExisting(headerDetails?.corrLinkId, 'top');
    dispatch(dispatchDisputeBodyDetails([]));

    const payload = {
      allQtr: getSelectionList.quarterRange === 'AQ' ? 'Y' : 'N',
      fromQtr:
        getSelectionList.quarterFrom !== ''
          ? getSelectionList.quarterFrom
          : null,
      toQtr:
        getSelectionList.quarterTo !== '' ? getSelectionList.quarterTo : null,
      status: getSelectionList.status,
      assignment: headerDetails.assignedUserId === '0' ? 'UNASSIGNED' : 'USER',
      secUserId:
        headerDetails.assignedUserId === '0'
          ? null
          : headerDetails.assignedUserId,
      overdue: getSelectionList.overdueOnly === true ? 'Y' : 'N',
      mfgId: headerDetails.mfgId,
      rpc: headerDetails.rebateProgramCd,
      planTypeCd: getSelectionList.planTypeCd,
    };
    dispatch(getMainGridDetails(payload));
    setStateGridCC(true);
  };

  // handling disputeHeader details in paginated form
  React.useEffect(() => {
    handleScrollToEvent();

    if (disputeHeaderDetails?.status === '001') {
      if (disputeHeaderDetails?.disputeDetailsHeader?.length > 0) {
        const newAllHeader = disputeHeaderDetails?.disputeDetailsHeader.map(
          (item, index) => {
            item.indexPaginate = index + 1;
            return item;
          }
        );
        dispatch(dispatchDisputeHeaderDetails(newAllHeader));

        getMainGridTableDetails(newAllHeader[0]);
        dispatch(dispatchSingleHeaderDetails(newAllHeader[0]));
        setTextBoxPaginate(1);

        setShowAllCheckbox(false);
        dispatch(
          selectionList({
            ...getSelectionList,
            showAllCorrespondence: false,
          })
        );
        dispatch(dispatchDisputeCorrespondenceTable([]));
        dispatch(handleErrorDetail([]));
      }
    }
  }, [disputeHeaderDetails]);

  // handling highlight tab
  React.useEffect(() => {
    if (detailErrorMessages && detailErrorMessages.length > 0) {
      tabHighLigther('/disputesDetails', true);
    } else {
      tabHighLigther('/disputesDetails', false);
    }
  }, [detailErrorMessages]);

  // handling show all correspondence action data
  const callCorrespondenceData = (rowData) => {
    dispatch(handleErrorDetail([]));
    setLoading(true);
    const payload = {
      rpc: getSelectionList.rebateProgramCd === 'ALL' ? 'ALL' : 'RPC',
      rpcInput:
        getSelectionList.rebateProgramCd === 'ALL'
          ? null
          : getSelectionList.rebateProgramCd,
      planTypeCd: getSelectionList.planTypeCd,
      overDue: getSelectionList.overdueOnly === true ? 'Y' : 'N',
      mfgId: rowData.mfgId,
      fromQtr: getSelectionList.quarterFrom,
      toQtr: getSelectionList.quarterTo,
      status: getSelectionList.status,
      assignment: getSelectionList.assignments,
      secUserId:
        getSelectionList.assignments === 'USER'
          ? getSelectionList.assignedTo
          : null,
    };
    dispatch(getAllCorrespondenceDetails(payload, showAllCheckbox));

    setLoading(false);
  };

  // handling highlight tab
  React.useEffect(() => {
    if (
      disputeManufacturerBodyDetails &&
      disputeManufacturerBodyDetails.length > 0 &&
      stateGridCC
    ) {
      handleExistingCommentList(disputeManufacturerBodyDetails);
      setStateGridCC(false);
    }
    if (
      disputeManufacturerBodyDetails &&
      disputeManufacturerBodyDetails.length > 0 &&
      checkKey
    ) {
      setCheckKey(false);
      disputeManufacturerBodyDetails.forEach((item) => {
        item.corpName = singleHeaderDetails?.corpName;
      });

      const newObj = disputeManufacturerBodyDetails?.map((item, index) => {
        if (index === 0) {
          item.value = true;
        } else {
          item.value = false;
        }
        return item;
      });
      dispatch(dispatchDisputeBodyDetails(newObj));
      paramsStore &&
        paramsStore.api.forEachNode(
          (node) => node.rowIndex === 0 && node.setSelected(true)
        );
      //callCorrespondenceData(disputeManufacturerBodyDetails[0]);
    }
  }, [disputeManufacturerBodyDetails]);

  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (
      showComments &&
      disputeManufacturerBodyDetails &&
      disputeManufacturerBodyDetails.length > 0
    ) {
      setStateCC(false);
      const tempObj = disputeManufacturerBodyDetails.map((item) => {
        if (
          item.corrLinkId === corrLinkId &&
          commentsList &&
          commentsList.length > 0
        ) {
          setStateCC(false);
          item.ccCommentsExist = 1;
        } else if (item.corrLinkId === corrLinkId) {
          item.ccCommentsExist = 0;
        }

        return item;
      });
      setStateCC(true);
      dispatch(dispatchDisputeBodyDetails(tempObj));
      // eslint-disable-next-line no-unused-expressions
      paramsStore?.api?.refreshCells();

      callCommentsExisting(singleHeaderDetails?.corrLinkId, 'top');
    }
  }, [commentsList]);

  // Handling refresh pagination
  React.useEffect(() => {
    if (singleHeaderDetails && singleHeaderDetails.indexPaginate) {
      setTextBoxPaginate(singleHeaderDetails.indexPaginate);
    }
  }, [singleHeaderDetails]);

  // set comment icon on if corrLinkId and comment is available
  const handleExistingCommentList = async (data) => {
    const result = await getExistingCorrLinkIds({
      corrLinkId: data.map((item) => {
        return item.corrLinkId;
      }),
    });

    const tempObj =
      data &&
      data?.length &&
      data.map((item) => {
        if (
          result &&
          result.data?.length > 0 &&
          result.data?.filter((x) => {
            return x === item.corrLinkId;
          }).length > 0
        ) {
          item.ccCommentsExist = 1;
        } else {
          item.ccCommentsExist = 0;
        }
        return item;
      });
    dispatch(dispatchDisputeBodyDetails(tempObj));

    // eslint-disable-next-line no-unused-expressions
    paramsStore?.api.refreshCells();
  };

  // handling by default row selection
  const onGridReady = (params) => {
    setParamsStore(params);
    if (
      disputeManufacturerBodyDetails &&
      disputeManufacturerBodyDetails?.length > 0
    ) {
      params.api.forEachNode(
        (node) =>
          node.rowIndex ===
            disputeManufacturerBodyDetails.findIndex((x) => {
              return x.corrLinkId === node.data.corrLinkId && x.value;
            }) && node.setSelected(true)
      );
    }
  };

  // handing full screen view
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };

  // regex to check its positive whole numbers or not
  function isNumeric(value) {
    return /^\d+$/.test(value);
  }

  // handling pagination from header
  const paginateData = (indexNumber, flag) => {
    dispatch(handleErrorDetail([]));
    if (!flag) {
      dispatch(
        selectionList({
          ...getSelectionList,
          paginateIndex: indexNumber,
        })
      );
      dispatch(
        selectionList({
          ...getSelectionList,
          showAllCorrespondence: false,
        })
      );
      setShowAllCheckbox(false);

      getMainGridTableDetails(disputeHeaderDetails[indexNumber]);
      dispatch(dispatchSingleHeaderDetails(disputeHeaderDetails[indexNumber]));
      dispatch(dispatchDisputeCorrespondenceTable([]));
      setTextBoxPaginate(disputeHeaderDetails[indexNumber].indexPaginate);
    } else {
      setTextBoxPaginate(indexNumber);
    }
    setCheckKey(true);
  };

  // handing Pagination validation on Blur event
  const handlePaginateBlur = () => {
    dispatch(handleErrorDetail([]));
    const arr = [];
    // eslint-disable-next-line no-unused-vars
    let isInputValue = false;

    const inputValue = isNumeric(textBoxPaginate);

    if ((inputValue && textBoxPaginate) > disputeHeaderDetails.length) {
      arr.push({
        field: 'input',
        errorType: 'inputIsGreter',
        message: constantMessageData.INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
      });
    } else {
      isInputValue = true;
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, { field: 'input', errorType: 'inputIsGreter' })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }
    }

    if (inputValue && isInputValue && textBoxPaginate !== '0') {
      const indexOf = !_.isEmpty(arr)
        ? _.findIndex(arr, { field: 'input', errorType: 'validate' })
        : null;
      if (!_.isNull(indexOf) && indexOf >= 0) {
        arr.splice(indexOf, 1);
      }

      setShowAllCheckbox(false);
      getMainGridTableDetails(
        disputeHeaderDetails[parseInt(textBoxPaginate, [1, 1000]) - 1]
      );
      dispatch(
        dispatchSingleHeaderDetails(
          disputeHeaderDetails[parseInt(textBoxPaginate, [1, 1000]) - 1]
        )
      );
      dispatch(dispatchDisputeCorrespondenceTable([]));
      setTextBoxPaginate(textBoxPaginate);
    } else {
      if (inputValue && textBoxPaginate < disputeHeaderDetails.length) {
        arr.push({
          field: 'input',
          errorType: 'validate',
          message: constantMessageData.ERR_PAGINATE_VALUE,
        });
      }
      if (inputValue === false) {
        arr.push({
          field: 'input',
          errorType: 'validate',
          message: constantMessageData.ERR_PAGINATE_VALUE,
        });
      }
    }
    dispatch(handleErrorDetail([...new Set(arr)]));
    window.scrollTo(0, 0);
  };
  // action to navigate to disputes based on NDC
  const goToNDCDisputeDetail = async (data) => {
    let localErr = detailErrorMessages || [];
    localErr = localErr.filter(
      (item) => item.field !== 'search' && item.field !== 'NDCsearch'
    );
    const payload = {
      qtr: data.qtr,
      secUserId: data.assignedUserID,
      rpc: data.rebateProgramCd,
      mfgId: data.mfgId,
      status: getSelectionList.status,
    };

    const response = await dispatch(getDisputeNdcDetails(payload));

    const asQtrOpt = getSelectionList.quarterRange === 'AQ' ? 'A' : 'R';
    const startQtr = getSelectionList.quarterFrom || '';

    const payloadDisputeCode = {
      endQtr: data.qtr,
      rebateProgramCode: data.rebateProgramCd,
      mfgId: data.mfgId,
      startQtr: startQtr, 
      asQtrOpt: asQtrOpt, 
      asDrugSel: 'D',
    };
    
    dispatch(getDisplayRecapGrid(payloadDisputeCode));

    if (response?.payload?.length > 0) {
      dispatch(singleDisputeNDCDetails(data));
      dispatch(
        statusType({
          open: getSelectionList.Open,
          closed: getSelectionList.Closed,
        })
      );
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) === null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));
      updateTabs.push({
        navTo: '/NDCDisputesDetails',
        value: 'View NDC Disputes Details',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
      props.history.push({
        pathname: '/NDCDisputesDetails',
      });
    } else {
      localErr.push({
        field: 'search',
        errorType: 'noResults',
        message: constantMessageData.MNFC_NDC_ERROR_MSG,
      });
      dispatch(handleErrorDetail([...new Set(localErr)]));
      window.scrollTo(0, 0);
    }
  };

  // select row one by one in dispute table grid
  const onRowSelect = (rowData) => {
    dispatch(handleErrorDetail([]));
    const newObj = disputeManufacturerBodyDetails?.map((item) => {
      if (
        rowData?.filter((x) => {
          return x.corrLinkId === item.corrLinkId;
        }).length > 0
      ) {
        item.value = true;
      } else {
        item.value = false;
      }
      return item;
    });
    dispatch(dispatchDisputeBodyDetails(newObj));

    // if (rowData?.length > 0) {
    //   callCorrespondenceData(rowData[0]);
    // }
  };

  // handling correspondence checkbox
  const correspondenceCall = (value) => {
    setShowAllCheckbox(value);
    dispatch(
      selectionList({
        ...getSelectionList,
        showAllCorrespondence: value,
      })
    );
    // if (value === true) {
    const findIndex = disputeManufacturerBodyDetails.findIndex(
      (item) => item.value === true
    );

    if (findIndex < 0) {
      const newObj = disputeManufacturerBodyDetails?.map((item, index) => {
        if (index === 0) {
          item.value = true;
        } else {
          item.value = false;
        }
        return item;
      });
      dispatch(dispatchDisputeBodyDetails(newObj));
      paramsStore &&
        paramsStore.api.forEachNode(
          (node) => node.rowIndex === 0 && node.setSelected(true)
        );
      callCorrespondenceData(disputeManufacturerBodyDetails[0]);
    } else {
      callCorrespondenceData(disputeManufacturerBodyDetails[findIndex]);
      }
    // }
  };

  // set comments data
  const commentsData = (status, table, corrLink) => {
    dispatch(handleErrorDetail([]));
    setShowComments(status);
    setLinkTable(table);
    setCorrLinkId(corrLink);
  };

  // custom frame component for actions and values on the tablegrid
  const detailsframeworkComponents = {
    CommentButtonCell: (cellInfo) => {
      return (
        <div className="tdCell frr-icon-btn-group">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
          >
            <Button
              type="button"
              aria-label="comment"
              title="comment"
              className="th-ic comment-ic frr-disabled-comment-btn"
              variant="text"
            >
              <img
                alt="comment"
                src={CommentIcon}
                style={{ width: '19px', height: '19px' }}
              />
            </Button>
          </OverlayTrigger>
        </div>
      );
    },
    IconButtonCell: (cellInfo) => {
      return (
        <div className="tdCell frr-icon-btn-group">
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
          >
            <Button
              aria-label="Action"
              title="Action"
              onClick={() =>
                commentsData(true, 'INVOICE_HEADER', cellInfo.data.corrLinkId)
              }
              className={`th-ic comment-ic ${
                parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1
                  ? 'frr-enabled-comment-btn'
                  : 'frr-disabled-comment-btn'
              }`}
              variant="text"
            >
              {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1 ? (
                <img
                  alt="comment"
                  src={CommentVisibleIcon}
                  style={{ width: '19px', height: '19px' }}
                />
              ) : (
                <img
                  alt="comment"
                  src={CommentIcon}
                  style={{ width: '19px', height: '19px' }}
                />
              )}
            </Button>
          </OverlayTrigger>
          <Dropdown className="icon-dropdown-container float-right">
            <Dropdown.Toggle className="icon-dropdown" aria-label="Export">
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
              >
                <SVGComponent iconName="Icon-export" />
              </OverlayTrigger>
            </Dropdown.Toggle>
            <Dropdown.Menu className="export_dropdown h-auto">
              <Dropdown.Item
                onClick={() => {
                  goToNDCDisputeDetail(cellInfo.data);
                }}
              >
                Go To NDC Dispute Detail
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      );
    },
    CheckBoxCell: (cellInfo) => {
      let name = '';
      if (cellInfo?.colDef?.headerName === 'Sys Ltr') {
        name = cellInfo.data.sysLetterInd;
      } else if (cellInfo?.colDef?.headerName === 'Valid Response') {
        name = cellInfo.data.dispValidResponseInd;
      }

      return (
        <>
          <div className="tbl-checkbox frr-checkbox-no-label">
            <FormControlLabel
              control={<Checkbox color="primary" />}
              label="checkbox"
              disabled
              checked={name == 1}
              data-testid="log-batch-table-grid-checkbox"
            />
          </div>
        </>
      );
    },
    currentDisputedAmt: (cellInfo) => {
      let isNegativeVal = false;
      if (
        cellInfo?.data?.ccOpenAmt &&
        cellInfo?.data?.ccOpenAmt !== 0 &&
        cellInfo?.data?.ccOpenAmt !== '0'
      ) {
        isNegativeVal = !(
          parseFloat(cellInfo?.data?.ccOpenAmt?.toString().split('$')[1]) >= 0
        );
      }

      return (
        <>
          {isNegativeVal ? (
            <div style={{ color: 'red' }}>{`(${cellInfo?.data?.ccOpenAmt
              ?.toString()
              ?.replace('-', '')
              .trim()})`}</div>
          ) : (
            <div>{`${cellInfo?.data?.ccOpenAmt}`}</div>
          )}
        </>
      );
    },
  };

  return (
    <>
      <div
        className="tabs-container frr-dispute"
        data-testid="dispute-details-id"
      >
        {!fullScreenView && (
          <CustomSeparator parent1="Research" parent2="Disputes Details" />
        )}
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              detailErrorMessages?.length > 0
                ? _.map(detailErrorMessages, (l) => l.message)
                : []
            ),
          ]}
        />

        <Spinner load={loading} />

        {!fullScreenView && (
          <>
            <Box className="alone-pagination mb-2">
              <Box>
                <Button
                  aria-label="Previous"
                  title="Previous"
                  className="btns rotate-left"
                  data-testid="uc-paginate-arrow-left"
                  disabled={
                    !(singleHeaderDetails?.indexPaginate > 1) ||
                    !isNumeric(singleHeaderDetails?.indexPaginate) ||
                    disputeHeaderDetails?.length <
                      singleHeaderDetails?.indexPaginate
                  }
                  onClick={() => {
                    if (singleHeaderDetails?.indexPaginate > 1) {
                      paginateData(
                        parseInt(textBoxPaginate, [0, 1000]) - 2,
                        false
                      );
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-arrow" />
                  <span className="hide-elm">Previous</span>
                </Button>
              </Box>
              <Box>
                <label className="m-0" htmlFor="paginate-count">
                  <TextField
                    id="paginate-count"
                    data-testid="uc-input-paginate"
                    variant="outlined"
                    className="searchInput input-count"
                    value={textBoxPaginate}
                    onChange={(e) => paginateData(e.target.value, true)}
                    onBlur={() => {
                      handlePaginateBlur();
                    }}
                    onKeyDown={(e) => {
                      if (e.keyCode === 9 || e.key === 'Enter') {
                        e.preventDefault();
                        e.target.blur();
                        handlePaginateBlur();
                      }
                    }}
                    size={'small'}
                  />
                </label>
              </Box>
              <Box className="btns"> of {disputeHeaderDetails?.length}</Box>
              <Box>
                <Button
                  aria-label="Next"
                  title="Next"
                  className="btns rotate-right ml-0"
                  data-testid="uc-paginate-arrow-right"
                  disabled={
                    singleHeaderDetails?.indexPaginate >
                      disputeHeaderDetails?.length - 1 ||
                    !isNumeric(singleHeaderDetails?.indexPaginate)
                  }
                  onClick={() => {
                    if (
                      singleHeaderDetails?.indexPaginate !==
                      disputeHeaderDetails?.length
                    ) {
                      paginateData(parseInt(textBoxPaginate, [0, 1000]), false);
                    }
                  }}
                >
                  <SVGComponent iconName="Icon-arrow" />
                  <span className="hide-elm">Next</span>
                </Button>
              </Box>
            </Box>

            <Box className="panel custom-fieldset">
              <div className="custom-check frr-info-top-part">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    {singleHeaderDetails?.rebateProgramCd ? (
                      <TextField
                        id="rebate_program"
                        label="Rebate Program"
                        fullWidth
                        required
                        reqColor
                        disabled
                        select
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ id: 'rebate_program' }}
                        value={singleHeaderDetails?.rebateProgramCd}
                      >
                        <MenuItem
                          key=""
                          value="-1"
                          className="frr-dropdown-blank-item"
                        />
                        <MenuItem key="ALL" value="ALL">
                          All Rebate Programs
                        </MenuItem>

                        {rebateProgramList &&
                        rebateProgramList.length &&
                        rebateProgramList.length > 0
                          ? rebateProgramList.map((item) => {
                              return (
                                <MenuItem key={item.id} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    ) : null}
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="row">
                      <div className="col-6">
                        <TextField
                          id="Manufacturer"
                          label="Manufacturer ID"
                          fullWidth
                          disabled
                          required
                          reqColor
                          placeholder=""
                          inputProps={{ id: 'Manufacturer' }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={singleHeaderDetails?.mfgId}
                        />
                      </div>
                      <div className="col-6 ">
                        {singleHeaderDetails?.corpName ? (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="com-tooltip">
                                {singleHeaderDetails?.corpName}
                              </Tooltip>
                            }
                          >
                            <TextField
                              id="qtr"
                              label="Manufacturer Name"
                              fullWidth
                              required
                              reqColor
                              disabled
                              placeholder=""
                              inputProps={{ id: 'qtr' }}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              value={`${singleHeaderDetails?.corpName?.substring(
                                0,
                                12
                              )} ...`}
                            />
                          </OverlayTrigger>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mui-custom-form input-md">
                    <TextField
                      id="assignedTo"
                      label="Qtr Range"
                      required
                      reqColor
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        getSelectionList?.quarterRange === 'AQ'
                          ? 'All'
                          : `${getSelectionList?.quarterFrom} - ${getSelectionList?.quarterTo}`
                      }
                    />
                  </div>
                </div>
                <div className="form-wrapper form-wrapper-col-4">
                  <div className="mui-custom-form input-md">
                    <TextField
                      autoFocus
                      id="NDC"
                      label="Assigned To"
                      required
                      reqColor
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        singleHeaderDetails?.assignedUserId === '0'
                          ? 'Unassigned'
                          : singleHeaderDetails?.assignedUserId
                      }
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="com-tooltip">
                          {singleHeaderDetails?.contactName}
                        </Tooltip>
                      }
                    >
                      <TextField
                        id="contact"
                        label="Contact"
                        fullWidth
                        disabled
                        required
                        reqColor
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={singleHeaderDetails?.contactName}
                      />
                    </OverlayTrigger>
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="lastAction"
                      label="Last Action"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={singleHeaderDetails?.lastActionDt}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="responseDue"
                      label="Response Due"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={
                        singleHeaderDetails?.responseDueDt
                          ? moment(singleHeaderDetails?.responseDueDt).format(
                              'MM/DD/YYYY'
                            )
                          : ''
                      }
                    />
                  </div>
                </div>
                <div className="form-wrapper form-wrapper-col-4">
                  <div className="mui-custom-form input-md">
                    <div className="comment-sec mt-2">
                      <img
                        role="button"
                        alt="comment"
                        src={
                          comments?.length > 0
                            ? CommentVisibleIcon
                            : CommentIcon
                        }
                        onClick={() =>
                          commentsData(
                            true,
                            'INVOICE_HEADER',
                            singleHeaderDetails.corrLinkId
                          )
                        }
                      />{' '}
                      Comments
                    </div>
                  </div>
                  <div className="mui-custom-form input-md frr-remove-label-marginLeft">
                    <div
                      className="form-wrapper db"
                    >
                      <FormControlLabel
                        data-testid="open_checked_ia"
                        control={<Checkbox color="primary" className="" />}
                        label="Open"
                        value={getSelectionList?.Open}
                        checked={getSelectionList?.Open}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md frr-remove-label-marginLeft">
                    <div
                      className="form-wrapper db"
                    >
                      <FormControlLabel
                        data-testid="closed_checked_ia"
                        control={<Checkbox color="primary" className="" />}
                        label="Closed"
                        value={getSelectionList?.Closed}
                        checked={getSelectionList?.Closed}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md frr-remove-label-marginLeft frr-showAll-checkbox">
                    <div
                      className="form-wrapper db frr-no-wrap"
                    >
                      <FormControlLabel
                        data-testid="checked_ia"
                        control={<Checkbox color="primary" className="" />}
                        label="Show All Correspondence"
                        value={showAllCheckbox}
                        checked={showAllCheckbox}
                        onChange={(e) => correspondenceCall(e.target.checked)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </>
        )}
        <div
          id="testGrid"
          className="panel-body FRR-custom-table tbl-manufacturer-inner"
        >
          {stateCC || disputeManufacturerBodyDetails?.length === 0 ? (
            <TableGrid
              ref={gridRef}
              data-testid="manufacturer-disputes-table"
              rowSelection="single"
              gridCall={onGridReady}
              rowMultiSelectWithClick={false}
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
              rowData={disputeManufacturerBodyDetails}
              onSelect={(e) => onRowSelect(e.api?.getSelectedRows())}
              columnDefs={TableHeaderForDisputesDetails}
              exportFile
              animateRows
              sideBar={false}
              fileName="Disputes-Details-Manufacturer"
              singleClickEdit
              navigateToNextCell={navigateToNextCell}
              tabToNextCell={tabToNextCell}
              enterMovesDown
              suppressCellFocus
              onCellFocused={onCellFocused}
              frameworkComponents={detailsframeworkComponents}
            />
          ) : null}
        </div>
        <div
          id="testGrid"
          className="panel-body FRR-custom-table tbl-manufacturer-inner"
        >
          {/* {showAllCheckbox ? ( */}
          <TableGrid
            data-testid="correspondence-disputes-table"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            rowData={
              disputeCorrespondenceDetails?.length > 0
                ? disputeCorrespondenceDetails
                : []
            }
            columnDefs={TableHeaderForDisputesCorrespondence}
            exportFile
            animateRows
            sideBar={false}
            fileName="Disputes-Correspondence"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            frameworkComponents={detailsframeworkComponents}
          />
          {/* ) : null} */}
        </div>
      </div>

      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName={linkTable}
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={singleHeaderDetails?.mfgId || ''}
        />
      ) : null}
    </>
  );
}
export default withRouter(ManufacturerDisputesDetail);
